import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import Arabic from "../../images/arabic title.png";
import { convertToRFT } from "../../utils/convertToRFT";
import { BoxesPacking } from "../features/BoxesPacking";
import WarehousePrint from "./WarehousePrint";
import address from "../../images/arabic address.png";
import html2pdf from "html2pdf.js";
import { Balance } from "@mui/icons-material";
import React from "react";
function NewStandardPrint({
  billNumber = "",
  customer = "",
  items = "",
  discount = "0",
  discountType = "",
  date = "",
  subTotal = "0",
  Total = "0",
  paid = "0",
  formallyOutstandings = "0",
  saleType = "",
  notes = "",
  printQuote,
  Quote = "",
  fivePercent = "",
  gst = 0,
  gstType = "",
  varTotal,
  income = "0",
  further = "0",
  ledger_address = "",
  companyNew,

}) {
  let temp = localStorage.getItem("template");
  let companyCode = localStorage.getItem("companyCode");
  let baseUrl = localStorage.getItem("base_url");
  let imgSrc = baseUrl ? baseUrl : employeeLogo;
  console.log("img", imgSrc);
  let user = localStorage.getItem("username") || localStorage.getItem("token");
  let company = localStorage.getItem("company");
  let address = localStorage.getItem("address");
  let phone1 = localStorage.getItem("p1");
  let phone2 = localStorage.getItem("p2");
  let phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  let employeeName = localStorage.getItem("username") || "";

  terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");
  const nameOne = " ابراہیم خان";
  const nameTwo = " اسامہ خان";
  const width = companyCode === "1153" ? "60%" : "100%";

  let totalQty = 0;
  let rows = items
    .map((item, i) => {
      console;
      let { saleQty, itemPrice, totalPrice, discountAmount, itemDiscount } =
        convertToRFT(saleType, item, "", fivePercent);
      totalQty += parseInt(saleQty);
      return `
    <tr style="height:25px">
 
   

                <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 8%; border: 2px solid #ccc;">${
                  totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3)
                }</td>
                  <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 10%; border: 2px solid #ccc;">${discountAmount}</td>

                <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 7%; border: 2px solid #ccc;">${itemDiscount}</td>
         <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 17%; border: 2px solid #ccc">${itemPrice}</td>

      <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 8%; border: 2px solid #ccc;">${
        saleQty % 1 === 0 ? saleQty : saleQty.toFixed(3)
      }</td>

      <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 20%; border: 2px solid #ccc;">${
        companyNew.imeiNumberShow == "yes" ?  item?.imeiNumber : item.description      }</td>
   
      <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 35%; border: 2px solid #ccc;">${
        item?.name
      }</td>
         <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 5%; border: 2px solid #ccc;">${
           i + 1
         }</td>
      </tr>`;
    })
    .join("");

  let htmlContent = `
  <div style=" ">
  <div style="display:flex;align-items:center; gap:7rem">
  <div style="">
<img src="${imgSrc}" style="width: ${"150px"}; height: ${"150px"};  " />
</div>

  <div style="display:flex;flex-direction:column; align-items:center;  margin-bottom:0rem;">

  ${
    companyCode !== "1153"
      ? `
      <div>
        <h1 style="display:flex;justify-content:center;font-size:32px;">${company}</h1>
      </div>
    `
      : ""
  }
         <p style="font-size: 12px; font-weight: 600; margin: 4px;">
  ${phone ? phone + " " : ""} 
  ${phone1 ? phone1 + " " : ""} 
</p>

     ${
       companyCode !== "1153"
         ? `
     <p style="display:flex;justify-content:center;font-size: 18px;font-weight:600;margin:4px;padding:2px;margin-bottom:3rem;">${address}</p> `
         : ""
     }
</div>





    ${
      temp === "thermalInvoice"
        ? `<h1>Invoice#</h1>`
        : `
 
<div style="display:flex;flex-direction:column"> 
  ${
    companyCode == "1153"
      ? `
      <div>
        <h1 style="display:flex;justify-content:center;font-size:32px;">${company}</h1>
      </div>
    `
      : ""
  }

   ${
     companyCode == "1153"
       ? `
     <p style="display:flex;justify-content:center;font-size: 18px;font-weight:600;margin:4px;padding:2px;">${address}</p> `
       : ""
   }

     </div>
     
 



    </div>
 

  <div style="display:flex;flex-direction:column; align-items:center; width: ${width}; margin-bottom:0rem;">
        <div style="display:flex;flex-direction:column">
         <p style="font-size: 12px; font-weight: 600; margin: 4px;">
           ${companyCode == "1153" ? nameOne : ""}
         </p>
 
</div>

        <div style="display:flex;flex-direction:column;">

    <p style="font-size: 12px; font-weight: 600; margin: 4px;">
           ${companyCode == "1153" ? nameTwo : ""}
         </p>

      
      
      <p style="font-size: 12px; font-weight: 600; margin: 4px;">
        ${phone2 ? phone2 : ""}</p>
</div>
</div>


      

      <div  style="display:flex;justify-content:space-between;border:2px solid black;width:94%;margin: 0 auto;">
          
       
      


     
      
        <div style="display:flex;justify-content: flex-end;border-right: 2px solid black;width:40%">
        <p style="font-size: 12px;font-weight:600;margin:4px;">${ledger_address}</p>

        <p style="font-size: 12px;font-weight:600;margin:4px;">${customer}</p>
                <p style="font-size: 12px;font-weight:600;margin:4px;margin-top:0px;">بل بنام</p>

      </div>
      <div style="display:flex;justify-content: flex-end;border-right: 2px solid black">
        <p style="font-size: 12px;font-weight:600;margin:4px">${billNumber}</p>
        <p style="font-size: 12px;font-weight:600;margin:4px;margin-top:0px;">بل نمبر</p>

   </div>

  <div style="display:flex;  justify-content: flex-end;border-right: 2px solid black">
  <p style="font-size: 12px;font-weight:600;margin:4px;">${employeeName}</p>
  <p style="font-size: 12px;font-weight:600;margin:4px;margin-top:0px;">ملازم</p>
</div>

    <div style="display:flex;  justify-content: flex-end;border-right: 2px solid black">
  <p style="font-size: 12px;font-weight:600;margin:4px;">${date}</p>
  <p style="font-size: 12px;font-weight:600;margin:4px;margin-top:0px;">تاریخ</p>
</div>



    </div>
    `
    }
    <table style=" text-align: center; margin:20px; border-collapse: collapse;">
      <thead style="height:25px">
        <tr style="font-size: 12px;font-weight:1000; border: 1px solid black;">
<th style="width: 17%; border: 2px solid black;">کل قیمت</th>

<th style="width: 10%; border: 2px solid black;">رعایت کی رقم</th>

<th style="width: 7%; border: 2px solid black;">رعایت</th>

<th style="width: 8%; border: 2px solid black;">قیمت</th>

<th style="width: 8%; border: 2px solid black;">مقدار</th>
<th style="width: 20%; border: 2px solid black;">${companyNew.imeiNumberShow == "yes" ?  "IMEI نمبر" : "تفصیل"}</th>


    <th style="width: 35%; border: 2px solid #000000;">آئٹم</th>

          <th style="width: 5%; border: 2px solid #000000;">#</th>

        </tr>
      </thead>
      <tbody style="border: 1px solid black;">
        ${rows}
      </tbody>
    </table>

 <div style="border: 2px solid black; width: 150px; font-size: 12px; font-weight: 600; text-align: center;margin-left:50px;">
  <div style="display: grid; grid-template-columns: 1fr 1fr; border-collapse: collapse;">
    <div style="border: 1px solid black; padding: 5px;">${Number(subTotal).toFixed(3)}</div>
    <div style="border: 1px solid black; padding: 5px;">ذیلی کل</div>

    <div style="border: 1px solid black; padding: 5px;">${discount || 0}</div>
    <div style="border: 1px solid black; padding: 5px;">رعایت</div>

    <div style="border: 1px solid black; padding: 5px;">${formallyOutstandings}</div>
    <div style="border: 1px solid black; padding: 5px;">سابقہ بقایا</div>

    <div style="border: 1px solid black; padding: 5px;">${Number(Total).toFixed(3)}</div>
    <div style="border: 1px solid black; padding: 5px;">کل</div>

    <div style="border: 1px solid black; padding: 5px;">${paid}</div>
    <div style="border: 1px solid black; padding: 5px;">کیش وصول</div>

    <div style="border: 1px solid black; padding: 5px;">${Number(Total - paid).toFixed(3)}</div>
    <div style="border: 1px solid black; padding: 5px;">موجودہ بقایا</div>
  </div>
</div>

   ${
     terms
       ? `
    <div style="display: flex; justify-content: center;">
      <p style="margin-top: 20px; font-size: 12px; text-align: center;">
      
        ${terms
          .replace(/\n/g, "<br>")
          .replace(/Phone\\s*no\\s*:\\s*\\d{11}(?:,\\d{11})*/g, "<br>$&")}
      </p>
    </div>
  `
       : ""
   }
   
  </div>
`;

  let opt = {
    margin: 0,
    filename: "receipt.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // A4 size in portrait
  };

  // html2pdf().from(htmlContent).set(opt).output('blob').then((blob) => {
  //   const url = URL.createObjectURL(blob);
  //   window.open(url, '_blank');
  // });}
  html2pdf()
    .from(htmlContent)
    .set(opt)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 100); // Wait a second for the PDF to load before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
}

export default NewStandardPrint;
